import React from 'react';

import TitleHelmet from '@/components/TitleHelmet';
import ReleasesList from '@/features/releases/components/ReleasesList';

import { withAuthenticationRequired } from '@auth0/auth0-react';
import styles from './releases.module.scss';

const Releases: React.FC = () => {
  return (
    <React.Fragment>
      <TitleHelmet title="Releases" />
      <ReleasesList />
    </React.Fragment>)
};

export default withAuthenticationRequired(Releases);
